import { useNavigate, useLocation } from "react-router-dom";
import Logo from "../../assets/logo.svg";
import iconDashboard from "../../assets/iconDashboard.png";
import iconEventos from "../../assets/iconEventos.png";
import iconOportunidades from "../../assets/iconOportunidades.png";
import iconCursos from "../../assets/iconCursos.png";
import iconConquistas from "../../assets/iconConquistas.png";
import { FileText } from "lucide-react";

import {
  SidebarContainer,
  LogoSection,
  LogoIcon,
  LogoText,
  NavList,
  NavItem,
  NavIcon,
  UserSection,
  LogoutButton,
  Img,
} from "./styles";

import { FiLogOut } from "react-icons/fi";

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { name: "Dashboard", icon: iconDashboard, path: "/dash" },
    { name: "Eventos", icon: iconEventos, path: "/eventos" },
    { name: "Oportunidades", icon: iconOportunidades, path: "/oportunidades" },
    { name: "Cursos", icon: iconCursos, path: "/cursos" },
    { name: "Conquistas", icon: iconConquistas, path: "/conquistas" },
    { name: "Relatórios", icon: FileText, path: "/relatorios" },
  ];

  const handleNavigation = (path) => {
    navigate(path);
  };

  const handleLogout = () => {
    // Adicione aqui a lógica de logout, como limpar token/localStorage
    navigate("/login"); // redireciona para a tela de login
  };

  return (
    <SidebarContainer>
      <div>
        {/* LOGO */}
        <LogoSection>
          <LogoIcon>
            <Img src={Logo} alt="Logo" />
          </LogoIcon>
          <LogoText>
            <h2>VOE+</h2>
            <span>Admin Panel</span>
          </LogoText>
        </LogoSection>

        {/* NAVIGAÇÃO */}
        <NavList>
          {navItems.map((item) => {
  const Icon = item.icon;

  return (
    <NavItem
      key={item.name}
      active={location.pathname === item.path}
      onClick={() => navigate(item.path)}
    >
      <NavIcon>
        {typeof Icon === "string" ? (
          <Img src={Icon} alt={item.name} />
        ) : (
          <Icon size={20} />
        )}
      </NavIcon>

      {item.name}
    </NavItem>
  );
})}
        </NavList>
      </div>

      {/* BOTÃO DE LOGOUT NO FINAL */}
      <UserSection>
        <LogoutButton onClick={handleLogout}>
          <FiLogOut size={20} />
          Sair
        </LogoutButton>
      </UserSection>
    </SidebarContainer>
  );
}
